import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './templates/login-1.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: '/Predict-Model';

    @ViewChild('alertSignin',
        { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSignup',
        { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass',
        { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/demo6/base/scripts.bundle.js'], true).then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });
            if ((!!localStorage.getItem('currentUser') == true)) {
                   localStorage.removeItem('currentUser')
                }
    }

    signin() {
        Helpers.setLoading(true);
        this._authService.login(this.model.email, this.model.password).subscribe(
            data => {
                if (data.token) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    this._router.navigate(['/Predict-Model']);
                    Helpers.setLoading(false);
                }
            },
            error => {
                this.outsession(error);
                this.showAlert('alertSignin');
                this._alertService.error('Invalid Credentials');
                Helpers.setLoading(false);
            });
    }

    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this._router.navigate(['/login'])
        }
    }

  

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
}


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/auth/auth.component.ts